/**
 * Created by mgoria on 1/20/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedToSendBatchSqsMessageException = undefined;

var _LogDriverException2 = require('./LogDriverException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when failed to send sqs message
 */
let FailedToSendBatchSqsMessageException = exports.FailedToSendBatchSqsMessageException = function (_LogDriverException) {
  _inherits(FailedToSendBatchSqsMessageException, _LogDriverException);

  /**
   * @param {String} sqsQueueUrl
   * @param {Object} error
   */
  function FailedToSendBatchSqsMessageException(sqsQueueUrl, error) {
    _classCallCheck(this, FailedToSendBatchSqsMessageException);

    return _possibleConstructorReturn(this, (FailedToSendBatchSqsMessageException.__proto__ || Object.getPrototypeOf(FailedToSendBatchSqsMessageException)).call(this, `Failed to send batch messages to ${sqsQueueUrl} SQS queue. ${error}`));
  }

  return FailedToSendBatchSqsMessageException;
}(_LogDriverException2.LogDriverException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/Exception/FailedToSendBatchSqsMessageException.js
// module id = 400
// module chunks = 0